import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';

import NoteModal from './NoteModal';
import { ROUTE_PATH } from './constants';

@withRouter
@inject('rootStore')
@injectIntl
@observer
class ModalSwitch extends React.Component {
  render() {
    const { rootStore } = this.props;

    const noteId = rootStore.pathname.includes('note') ? '' : '/note/:noteId';

    var path =
      rootStore.pathname !== `${ROUTE_PATH}`
        ? `${rootStore.pathname}${noteId}`
        : `${ROUTE_PATH}${noteId}`;

    const r = RegExp('note/\\d+');
    const newPath = path.replace(r, 'note/:noteId');
    return <Route path={newPath} component={() => <NoteModal />} />;
  }
}

export default ModalSwitch;
